import { library } from '@fortawesome/fontawesome-svg-core'

import {
  faAddressCard,
  faUserCircle,
  faSpinner,
  faTimes,
  faFile,
  faCloudUploadAlt,
  faInfoCircle,
  faExclamationTriangle,
  faArrowCircleDown,
  faArrowCircleUp,
  faArrowCircleRight,
  faCircle,
  faTachometerAlt,
  faDesktop,
  faEdit,
  faStoreAlt,
  faCog,
  faChartBar,
  faChartLine,
  faGlobe,
  faEnvelope,
  faAt,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faExclamationCircle,
  faPhone,
  faImage,
  faImages,
  faChartPie,
  faBullseye,
  faSearchLocation,
  faCheckCircle,
  faTimesCircle,
  faPauseCircle,
  faCheck,
  faTrash,
  faQuestionCircle,
  faSearch,
  faRedoAlt,
  faPlayCircle,
  faPenSquare,
  faComment
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faAddressCard,
  faUserCircle,
  faSpinner,
  faTimes,
  faFile,
  faCloudUploadAlt,
  faInfoCircle,
  faExclamationTriangle,
  faArrowCircleDown,
  faArrowCircleUp,
  faArrowCircleRight,
  faCircle,
  faTachometerAlt,
  faDesktop,
  faEdit,
  faStoreAlt,
  faCog,
  faChartBar,
  faChartLine,
  faGlobe,
  faEnvelope,
  faAt,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faExclamationCircle,
  faPhone,
  faImage,
  faImages,
  faChartPie,
  faBullseye,
  faSearchLocation,
  faCheckCircle,
  faTimesCircle,
  faPauseCircle,
  faCheck,
  faTrash,
  faQuestionCircle,
  faSearch,
  faRedoAlt,
  faPlayCircle,
  faPenSquare,
  faComment
)
